import PageLayout from "@/components/feature/PageLayout";
import Seo from "@/components/feature/Seo";
import HeroSection from "./components/HeroSection";
import PicksSection from "./components/PicksSection";
import CategoryExploreSection from "./components/CategoryExploreSection";
import HotRankSection from "./components/HotRankSection";
import ValuesSection from "./components/ValuesSection";
import CommunitySection from "./components/CommunitySection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <PageLayout dark={false}>
      <Seo
        title="看料 - 看料精选与热门推荐，编辑每日甄选值得看的好料"
        description="看料是编辑团队每日甄选的内容推荐平台，汇集看料精选、看料热门推荐与编辑力荐榜单，覆盖数字工作、阅读新知、生活灵感与认知成长等热门主题，帮你每天不错过值得看的好料。"
        keywords="看料,看料精选,看料热门推荐,看料推荐,看料内容推荐,编辑推荐,每日好料"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "看料",
            url: "https://01x0wyo.cn/",
            description: "编辑团队每日甄选的内容推荐平台，覆盖数字工作、阅读新知、生活灵感与认知成长。",
            email: "hello@kanliao.example",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "看料",
            url: "https://01x0wyo.cn/",
            inLanguage: "zh-CN",
            description: "看料精选与热门推荐，编辑团队每日甄选值得看的好料。",
          },
        ]}
      />

      <HeroSection />
      <PicksSection />
      <CategoryExploreSection />
      <HotRankSection />
      <ValuesSection />
      <CommunitySection />
      <FaqSection />
      <CtaSection />
    </PageLayout>
  );
}